import { captureException } from '@sentry/react';

/**
 * Builds an error reporter: logs, captures to Sentry and, given `setNotification`, shows the error snackbar.
 * Curried to match the stores' `onError(message)(error)` shape.
 * @param {(notification: { severity: string, message: string }) => void} [setNotification]
 * @returns {(message?: string) => (error: Error) => void}
 * @example const onError = reportError(setNotification); useMutation(M, { onError: onError('Failed to save') });
 */
export const reportError = (setNotification) => (message) => (error) => {
    console.error(error);
    captureException(error);
    setNotification?.({ severity: 'error', message: message || 'Something went wrong' });
};
